module.exports = __webpack_public_path__ + "img/liulan@3x.c65646c5.png";